<template>
  
          <ListVideosSentByClient></ListVideosSentByClient>
        
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ListVideosSentByClient from "@/components/admin/client/video/listVideos.vue";

// import Api from "@/core/services/api.service";
// import Swal from "sweetalert2";

export default {
  name: "contentClient",
  components: {
    ListVideosSentByClient,
  },
  data: () => ({
   
  }),

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration" },
      { title: "Gestion des contenus des clients" },
    ]);
  },
  methods: {
    
  }
};
</script>
